<section #apoRegistrationProcessQuestionaire>
  <ng-container *ngIf="submitted">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <header>
            <h3>Hartelijk dank voor het invullen van deze vragenlijst</h3>
          </header>
          <p>Bedankt voor het invullen van de vragenlijst! We waarderen je tijd en input enorm. Jouw feedback helpt ons om te blijven verbeteren.</p>
          <h4>OuderServicedesk</h4>
          <p>
            Wilt u specifiek iets kwijt, of heeft u behoefte aan contact, stuur dan een e-mail naar 
            <a href="mailto:ouders@aanmeldenpo.nl">ouders&#64;aanmeldenpo.nl</a>.
            Vermeld hierbij uw vraag of het onderwerp, zodat we u zo goed mogelijk kunnen helpen.
          </p>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="container" *ngIf="!submitted">
    <div class="row">
      <div class="col-sm-12">
        <header>
          <h3>Vragenlijst aanmelden basisschool</h3>
          <p>
            Beste ouder(s)/verzorger(s), <br /><br />
            AanmeldenPO is verantwoordelijk voor het uitvoeren van de aanmeldprocedure bij de
            basisschool. We willen deze procedure voor iedereen zo goed mogelijk laten verlopen.
            Daarom vragen we doorlopend naar de ervaringen van ouders/verzorgers.<br /><br />
            Deze enquête bestaat uit zes vragen. Het invullen van deze enquête is anoniem en
            duurt slechts een paar minuten. Alvast hartelijk dank voor het invullen.
          </p>
        </header>

        <form [formGroup]="questionnaire" (ngSubmit)="onSubmit()" class="form">
          <div class="form-group">
            <h4>Is uw kind aangemeld bij een Haagse basisschool?</h4>
            <div class="form-vertical-inputs">
              <label *ngFor="let answer of objectValues(ChildRegistrerd);">
                <input class="form-control" type="radio" name="child_registrerd"
                  [formControl]="questionnaire.controls.child_registrerd" [value]="answer" />
                <span>{{ answer }}</span>
              </label>
            </div>
            <ng-container
              *ngIf="!questionnaire.controls.child_registrerd.valid && questionnaire.controls.child_registrerd.touched">
              <p class="form-warning">{{'REQUIRED_FIELD' | translate}}</p>
            </ng-container>
          </div>

          <div class="form-group" *ngIf="questionnaire.controls.child_registrerd.value === ChildRegistrerd.NO">
            <label class="label-vertical">
              <span>Toelichting (verplicht)</span>
              <textarea row="5" [formControl]="questionnaire.controls.child_registrerd_explanation"></textarea>
            </label>
            <ng-container *ngIf="!questionnaire.controls.child_registrerd_explanation.valid && questionnaire.controls.child_registrerd_explanation.touched">
              <p class="form-warning">{{'REQUIRED_FIELD' | translate}}</p>
            </ng-container>
          </div>

          <div class="form-group">
            <div class="form-group-header">
              <h4>Wanneer is uw kind geboren?</h4>
            </div>
            <div class="form-horizontal-inputs form-horizontal-inputs--start">
              <label class="select-label">
                <span>Maand</span>
                <select [formControl]="questionnaire.controls.child_birth_month">
                  <option *ngFor="let month of months" [value]="month">{{ month }}</option>
                </select>
              </label>
              <label class="select-label">
                <span>Jaar</span>
                <select [formControl]="questionnaire.controls.child_birth_year">
                  <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                </select>
              </label>
            </div>
            <ng-container
              *ngIf="
                (!questionnaire.controls.child_birth_month.valid && questionnaire.controls.child_birth_month.touched) 
                || (!questionnaire.controls.child_birth_year.valid && questionnaire.controls.child_birth_year.touched)"
            >
              <p class="form-warning">{{'REQUIRED_FIELD' | translate}}</p>
            </ng-container>
          </div>

          <div class="form-group">
            <div class="form-group-header">
              <h4>Hoe tevreden bent u over de aanmeldprocedure van AanmeldenPO?</h4>
              <b>(1 = zeer ontevreden, 10 = zeer tevreden)</b>
            </div>
            <div class="form-horizontal-inputs">
              <label class="satisfaction-input" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
                <span>{{ i }}</span>
                <input type="radio" name="satisfaction" [formControl]="questionnaire.controls.satisfaction"
                  [value]="i" />
              </label>
            </div>
            <ng-container
              *ngIf="!questionnaire.controls.satisfaction.valid && questionnaire.controls.satisfaction.touched">
              <p class="form-warning">{{'REQUIRED_FIELD' | translate}}</p>
            </ng-container>
          </div>

          <div class="form-group">
            <div class="form-group-header">
              <h4>Waar bent u <u>tevreden</u> over? </h4>
              <b>(meerdere antwoorden mogelijk)</b>
            </div>
            <div class="form-vertical-inputs">
              <label *ngFor="let answer of objectValues(QuestionaireSubjects); let i = index">
                <input class="form-control" type="checkbox"
                  [formControl]="questionnaire.controls.happy_about.controls[i]" />
                <span>{{ answer }}</span>
              </label>
            </div>
            <ng-container
              *ngIf="!questionnaire.controls.happy_about.valid && questionnaire.controls.happy_about.touched">
              <p class="form-warning">{{'REQUIRED_FIELD' | translate}}</p>
            </ng-container>
          </div>

          <div class="form-group">
            <label>
              <span>U kunt hier een toelichting geven op uw antwoord(en)</span>
              <textarea row="5" [formControl]="questionnaire.controls.happy_about_explanation"></textarea>
            </label>
            <div class="character-counter">
              <span>{{ questionnaire.controls.happy_about_explanation.value?.length ?? 0 }}/4000</span>
            </div>
            <ng-container *ngIf="!questionnaire.controls.happy_about_explanation.valid && questionnaire.controls.happy_about_explanation.touched">
              <p class="form-warning">{{'REQUIRED_FIELD' | translate}}</p>
            </ng-container>
          </div>

          <div class="form-group">
            <div class="form-group-header">
              <h4>Waar bent u <u>niet tevreden</u> over? </h4>
              <b>(meerdere antwoorden mogelijk)</b>
            </div>
            <div class="form-vertical-inputs">
              <label *ngFor="let answer of objectValues(QuestionaireSubjects); let i = index">
                <input class="form-control" type="checkbox"
                  [formControl]="questionnaire.controls.unhappy_about.controls[i]" />
                <span>{{ answer }}</span>
              </label>
            </div>
            <ng-container
              *ngIf="!questionnaire.controls.unhappy_about.valid && questionnaire.controls.unhappy_about.touched">
              <p class="form-warning">{{'REQUIRED_FIELD' | translate}}</p>
            </ng-container>
          </div>

          <div class="form-group">
            <label>
              <span>U kunt hier een toelichting geven op uw antwoord(en)</span>
              <textarea rows="5" [formControl]="questionnaire.controls.unhappy_about_explanation"></textarea>
            </label>
            <div class="character-counter">
              <span>{{ questionnaire.controls.unhappy_about_explanation.value?.length ?? 0 }}/4000</span>
            </div>
            <ng-container *ngIf="!questionnaire.controls.unhappy_about_explanation.valid && questionnaire.controls.unhappy_about_explanation.touched">
              <p class="form-warning">{{'REQUIRED_FIELD' | translate}}</p>
            </ng-container>
          </div>

          <div class="form-group">
            <h4>Welke verbeterpunten heeft u voor de aanmeldprocedure bij de basisschool?</h4>
            <textarea rows="5" [formControl]="questionnaire.controls.improvement_points"></textarea>
            <div class="character-counter">
              <span>{{ questionnaire.controls.improvement_points.value?.length ?? 0 }}/4000</span>
            </div>
          </div>

          <div class="form-group">
            <h4>OuderServicedesk</h4>
            <p>
              Wilt u specifiek iets kwijt, of heeft u behoefte aan contact, stuur dan een e-mail naar 
              <a href="mailto:ouders@aanmeldenpo.nl">ouders&#64;aanmeldenpo.nl</a>.
              Vermeld hierbij uw vraag of het onderwerp, zodat we u zo goed mogelijk kunnen helpen.
            </p>
          </div>

          <div class="form-group">
            <re-captcha [formControl]="questionnaire.controls.captcha" size="normal" theme="light" type="image"
              badge="inline"></re-captcha>
            <p class="form-warning"
              *ngIf="!questionnaire.controls.captcha.valid && questionnaire.controls.captcha.touched">{{'REQUIRED_FIELD'
              | translate}}</p>
          </div>

          <div class="form-group">
            <button type="submit">
              {{'SEND' | translate}}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="figure-1"></div>
  <div class="figure-2"></div>
  <div class="figure-3"></div>
  <div class="figure-4"></div>
  <div class="figure-5"></div>
</section>